import {
  JOB_ACTIONS,
  JOB_ADDED,
  JOB_STATUSES,
  JOB_UPDATED,
} from 'containers/App/Header/JobManagement/constants';
import { takeEvery } from 'containers/ErrorBoundary';
import { all, call } from 'redux-saga/effects';
import { requestMessage } from 'utils/request/requestMessage';
import { FETCH_ADVANCED } from './constants';
import { fetchAdvancedSaga } from './helpers';

function* jobAddedSaga(action) {
  const jobs = action.payload;
  if (Array.isArray(jobs)) {
    const cleanDbStarted = jobs.some(
      (job) =>
        job.action === JOB_ACTIONS.cleanDb &&
        job.status === JOB_STATUSES.scheduled,
    );
    if (cleanDbStarted) {
      yield call(requestMessage, 'success', 'cleanDbScheduled');
    }
  }
}

function* jobUpdateSaga(action) {
  const jobs = action.payload;
  if (Array.isArray(jobs)) {
    const cleanDbDone = jobs.some(
      (job) =>
        job.action === JOB_ACTIONS.cleanDb && job.status === JOB_STATUSES.done,
    );
    if (cleanDbDone) {
      yield call(
        requestMessage,
        'success',
        'settingsAdvancedSystemClearDBSuccess',
      );
    }
  }
}

export function* defaultSaga() {
  yield all([
    takeEvery(FETCH_ADVANCED, fetchAdvancedSaga),
    takeEvery(JOB_ADDED, jobAddedSaga),
    takeEvery(JOB_UPDATED, jobUpdateSaga),
  ]);
}

export default defaultSaga;
